export default __webpack_public_path__ + "static/quote-video-5-3dfcf04f33b86fdec15ce2697fa2a0ef.mp4";